import React from "react";
import { Typography, withStyles } from '@material-ui/core';
import styles from './style';
import Button from 'storybookComponents/Button';
import "./assets/print.css";
import printSrc from "./assets/print.png";
import Modal from 'components/Modal'
import TabBar from "storybookComponents/TabBar"
import IFrame from "./Iframe"
import MobilePreviewComponent from 'storybookComponents/MobilePreview/index';
import { makeSMSEditable } from "./EditableTemplates/editableConfirmSMS"
import { parseStringToHtml, getWidth, getEmailsGroup } from "./utils"
import EmailTab from "./EmailTab"

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

const MobilePreview = withStyles(styles)(({ id, emailSubject, classes, title, isDrawerOpen, imageData, confirmSmsBody, inviteSmsBody, confirmPageHtml, flyerHtml, landingPageHtml, cancelRsvpPageHtml, waitlistedPageHtml, removeFromWaitlistPageHtml, orgColors, setActivePreviewTab, showNotification, timezoneString, handleToggleEmails, ...props }) => {
  // console.log("fdfgfg", props.inviteEmailHtml)

  const [openPrintModal, setOpenPrintModal] = React.useState(false);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [subTab, setSubTab] = React.useState('Desktop');
  const [arrayIndex, setIndex] = React.useState(0);
  const [disableSms, setDisableSMS] = React.useState(false)
  const width = getWidth(isDrawerOpen);
  const emailsGroups = getEmailsGroup(props)

  const previews = {
    0: {
      Desktop: landingPageHtml,
      Mobile: landingPageHtml,
    },
    1: {
      Desktop: [confirmPageHtml, cancelRsvpPageHtml, waitlistedPageHtml, removeFromWaitlistPageHtml],
      SMS: [makeSMSEditable(`<html><head><style type="text/css"></style> </head><body><div id="confirm-message-container">
          <div><img style="width:100%; border-radius:10px;" src = "${imageData}"/></div>
          <div class="event-message-body" style="background:#f9f9f9; padding:10px; margin-top:10px; border-radius:10px;">${parseStringToHtml(confirmSmsBody, id)}</div></div></body></html>`)],
    },
    2: {
      email: [],
    },
    3: {
      "print": flyerHtml,
      "download": flyerHtml
    }
  }

  const indexChangeCallback = (index) => {
    setIndex(index);
    if (index == 0) {
      setDisableSMS(false)
    } else {
      setDisableSMS(true)
    }
    setActiveTabValue(tabIndex, subTab, index)
  }

  const setActiveTabValue = (tab, subTab, confirmArrayIndex) => {
    if (tab == 1 && subTab == "SMS") {
      setActivePreviewTab("sms")
      return;
    }

    setActivePreviewTab("disable")
    return
  }

  const handleChangesubTab = (index) => {
    setSubTab(index);
    setActiveTabValue(tabIndex, index, arrayIndex);
  }


  const changeTabIndex = (index) => {
    setTabIndex(index)
    let keys = Object.keys(previews[index]);
    setSubTab(keys[0])
    setIndex(0);
    setActiveTabValue(index, keys[0], 0)
  }



  const handlePrint = () => {
    let printableContent = document.getElementById("Iframe").contentWindow
    printableContent.focus()
    printableContent.print()
    setOpenPrintModal(false)
  }

  return (
    <div >
      <div className={classes.rootContainer}>
        <TabBar
          tabs={["Landing Page", "Confirmation Pages", "Emails", "Flyer"]}
          onChange={changeTabIndex}
          index={tabIndex}
        />
        <div className={classes.rightButtons}>
          {
            tabIndex === 3 ? <div className={classes.rightButtons}>
              <img src={printSrc} className={classes.printImg} onClick={() => setOpenPrintModal(true)} />
            </div> :
              tabIndex === 2 ? null :
                Object.keys(previews[tabIndex]).map((label, index) => {
                  return <>
                    <Button className={classes.rightButtonCSS} state={label === "SMS" && disableSms ? 'inactive' : 'active'} variant="tertiary" onClick={() => handleChangesubTab(label)}>
                      <div className={`${label !== subTab && classes.inactiveCSS}`}>
                        {label}
                      </div>
                    </Button>
                    {index !== Object.keys(previews[tabIndex]).length - 1 && <div className={classes.separator} />}
                  </>
                })
          }
        </div>
      </div>
      <div className={classes.previewContainer}>
        {
          tabIndex == 2 ?
            <EmailTab
              classes={classes}
              timezoneString={timezoneString}
              showNotification={showNotification}
              username={props.username}
              smsEnabled={props.smsEnabled}
              {...emailsGroups}
              orgColors={orgColors}
              handleToggleEmails={handleToggleEmails}
            />
            :
            (subTab === "Mobile" || subTab === "SMS") ? <MobilePreviewComponent smsView={subTab === "SMS"} html={previews[tabIndex][subTab]} /> :
              <IFrame indexChangeCallback={indexChangeCallback} srcDoc={previews[tabIndex][subTab]} scrolling="no" className={classes.frameContainer} dimesions={width[tabIndex][subTab]} classes={classes} />
        }
      </div>

      <Modal
        open={openPrintModal}
        handleClose={() => setOpenPrintModal(false)}
        title="Print Information"
        actionChildren={<Button className={classes.printBtn} onClick={handlePrint}>Continue</Button>}
      >
        <Typography className={classes.printDescription}>Follow the below print instructions to hide the browser defaults like header, footer.</Typography>
        {isSafari ? <>
          <Typography className={classes.printDescription2}>
            <span>1:</span> Change orientation to <span>Portrait</span>
          </Typography>
          <img className={classes.printImages} src="/print/safari-1.png" />
          <Typography className={classes.printDescription2}>
            <span>2:</span> Check <span>Print backgrounds</span> and Uncheck <span>Print headers and footers</span>
          </Typography>
          <img className={classes.printImages} src="/print/safari-2.png" />
        </> : <>
            <Typography className={classes.printDescription2}>
              <span>1:</span> Change Layout to <span>Portrait</span>
            </Typography>
            <img className={classes.printImages} src="/print/chrome-1.png" />
            <Typography className={classes.printDescription2}>
              <span>2:</span> Click to expand <span>More settings</span>
            </Typography>
            <img className={classes.printImages} src="/print/chrome-2.png" />
            <Typography className={classes.printDescription2}>
              <span>3:</span> Uncheck <span>Headers and footers</span> and Check <span>Background graphics</span>
            </Typography>
            <img className={classes.printImages} src="/print/chrome-3.png" />
          </>}
      </Modal>
    </div>
  )
});

export default MobilePreview
